var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [{ name: "DragDialog", rawName: "v-DragDialog" }],
      on: { DragDialog: () => {} },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible",
            },
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "dialogCallPhone el-dialog",
          attrs: {
            "element-loading-spinner": "el-icon-loading",
            "element-loading-background": "rgba(0, 0, 0, 0.8)",
          },
          on: { click: _vm.dialogVisibleClick },
        },
        [
          _c("div", { staticClass: "drag-callPhone-header el-dialog__header" }),
          _c("div", { staticClass: "icon" }, [
            _vm.status < 3
              ? _c("img", {
                  attrs: {
                    src: require("@/assets/image/outboundSeats/callpending.png"),
                    alt: "",
                  },
                })
              : _vm._e(),
            _vm.status === 3
              ? _c("img", {
                  attrs: {
                    src: require("@/assets/image/outboundSeats/call.png"),
                    alt: "",
                  },
                })
              : _vm._e(),
          ]),
          _c("div", { staticClass: "callTextStatus" }, [
            _vm._v(_vm._s(_vm.status < 3 ? "呼叫中" : "通话中")),
          ]),
          _c("div", { staticClass: "callPhoneNumber" }, [
            _vm._v(
              " 被叫：" +
                _vm._s(
                  _vm.mapEncryptionPhone(_vm.phoneTmp || _vm.phoneNumber)
                ) +
                " "
            ),
          ]),
          _c("div", { staticClass: "callBtn", on: { click: _vm.callClick } }, [
            _c("img", {
              attrs: {
                src: require("@/assets/image/outboundSeats/canceCall.png"),
                alt: "",
              },
            }),
            _vm._v(" " + _vm._s(_vm.status < 3 ? "取消呼叫" : "挂断") + " "),
          ]),
          _c(
            "div",
            { staticClass: "flex flex-middle flex-center" },
            [
              _vm.isAutoCall
                ? _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.checked,
                        callback: function ($$v) {
                          _vm.checked = $$v
                        },
                        expression: "checked",
                      },
                    },
                    [_vm._v(" 本页自动呼叫下一个 ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }